// extracted by mini-css-extract-plugin
export default {"container":"OriginBanner_container__WAENI","loginHolder":"OriginBanner_loginHolder__-dUWt","fbButton":"OriginBanner_fbButton__hK1RM"};